import PropTypes from "prop-types";

export default function ChartCard({ title, badge, children, style }) {
  return (
    <div className="chart-card" style={style}>
      <div className="chart-card__header">
        <span className="chart-card__title">{title}</span>
        {badge && <span className="chart-card__badge">{badge}</span>}
      </div>
      {children}
    </div>
  );
}

ChartCard.propTypes = {
  title: PropTypes.string.isRequired,
  badge: PropTypes.node,
  children: PropTypes.node.isRequired,
  style: PropTypes.object,
};

ChartCard.defaultProps = {
  badge: null,
  style: undefined,
};
